import { RequestError } from '@swf/core/errors/RequestError';

function getErrorStatusCode(error: unknown): number {
  return error instanceof RequestError && error.headers?.statusCode
    ? Number(error.headers.statusCode)
    : 500;
}

export default getErrorStatusCode;
